module.exports = __webpack_public_path__ + "static/img/hz.75a831e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz.jpg
// module id = x5Df
// module chunks = 0